// ImportLeadDialog.jsx
import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    CircularProgress,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { importLeads } from '../../../store/slices/leadsSlice';
import { toast } from 'react-toastify';

const ImportLeadDialog = ({ open, onClose }) => {
    const dispatch = useDispatch();
    const [file, setFile] = useState(null);
    const [importType, setImportType] = useState(''); // you can pre-fill or add options
    const [loading, setLoading] = useState(false);

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    };

    const handleImport = async () => {
        if (!file) {
            alert('Please select a file');
            return;
        }

        setLoading(true);

        const formData = new FormData();
        formData.append('file', file);
        // If your API expects additional fields (e.g. type, source, etc.), add them here
        // formData.append('importType', importType);

        try {
            await dispatch(importLeads(formData)).unwrap();
            onClose(true); // pass true to indicate success so parent can refresh data
        } catch (error) {
            const message =
                error.response?.data?.message ||
                error.message ||
                'Failed to import leads';
            toast.error(message)
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        if (!loading) {
            setFile(null);
            setImportType('');
            onClose(false);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Import Lead Data</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ mb: 3 }}>
                    Upload a file containing lead data. Supported formats are usually CSV or Excel.
                </DialogContentText>

                {/* File Input */}
                <Box sx={{ mb: 3 }}>
                    <input
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        style={{ display: 'none' }}
                        id="raised-button-file"
                        type="file"
                        onChange={handleFileChange}
                    />
                    <label htmlFor="raised-button-file">
                        <Button variant="outlined" component="span" fullWidth>
                            {file ? file.name : 'Choose File'}
                        </Button>
                    </label>
                    {file && (
                        <Button
                            size="small"
                            onClick={() => setFile(null)}
                            sx={{ ml: 1 }}
                            color="error"
                        >
                            Clear
                        </Button>
                    )}
                </Box>

                {/* Optional: Select field if you have different import types */}
                {/* 
        <FormControl fullWidth>
          <InputLabel>Import Type</InputLabel>
          <Select
            value={importType}
            label="Import Type"
            onChange={(e) => setImportType(e.target.value)}
          >
            <MenuItem value="standard">Standard Leads</MenuItem>
            <MenuItem value="meeting">Leads with Meeting</MenuItem>
            // add more as needed
          </Select>
        </FormControl>
        */}
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose} disabled={loading}>
                    Cancel
                </Button>
                <Button
                    onClick={handleImport}
                    variant="contained"
                    disabled={!file || loading}
                    startIcon={loading ? <CircularProgress size={20} /> : null}
                >
                    Import
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ImportLeadDialog;